import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.mentalClassList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.mentalClassList.error;
export const mentalClassListDataResponse = (state: RootState) =>
  state.mentalClassList.classListResponse;
